import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import { Modal } from '@app/components';
import { packageTypes } from '@app/constants/package';
import PackageButton from './PackageButton';
import { PackageBase } from './PackageStyledComponents';

class Package extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isInfoVisible: false };
  }

  render() {
    const {
      option, onOptionSelect, selected, disabled, hasMargin,
    } = this.props;
    const { isInfoVisible } = this.state;

    return (
      <React.Fragment>
        <PackageBase selected={selected} hasMargin={hasMargin}>
          <Name>{get(option, 'name', '')}</Name>
          {
            get(option, 'type', packageTypes.DEFAULT) !== packageTypes.FREE_TRIAL
            && (
              <MoreInfo onClick={() => this.setState({ isInfoVisible: true })}>
                +&nbsp;
                <FormattedMessage id="package.moreInfo" />
              </MoreInfo>
            )
          }
          <Select>
            {
              get(option, 'type', packageTypes.DEFAULT) === packageTypes.FREE_TRIAL
                ? (<Price dangerouslySetInnerHTML={{ __html: get(option, 'synopsis', '') }} />)
                : (
                  <Price>
                    $&nbsp;
                    {get(option, 'priceWithoutVat', '00.00')}
                  </Price>
                )
            }
            <PackageButton option={option} onButtonClick={onOptionSelect} disabled={disabled} />
          </Select>
        </PackageBase>
        <Modal
          show={isInfoVisible}
          onHide={() => this.setState({ isInfoVisible: false })}
        >
          <h2>{get(option, 'name', '')}</h2>
          {/* eslint-disable-next-line */}
          <p dangerouslySetInnerHTML={{ __html: option.synopsis }} />
        </Modal>
      </React.Fragment>
    );
  }
}

Package.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string,
    priceWithoutVat: PropTypes.number,
  }),
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  hasMargin: PropTypes.bool,
  onOptionSelect: PropTypes.func,
};

Package.defaultProps = {
  option: {
    name: '',
    priceWithoutVat: '00.00',
  },
  selected: false,
  disabled: false,
  hasMargin: true,
  onOptionSelect: () => {},
};

const Name = styled.p`
  margin: 0;
  font-size: 20px;
`;

const MoreInfo = styled.p`
  margin: 0;
  font-size: 18px;
  cursor: pointer;
`;

const Select = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

const Price = styled.p`
  margin-bottom: 20px;
  font-size: 26px;
  text-align: left;
  width: 100%;
  max-width: 220px;
`;

export default Package;
